<template>
  <div>
    <modal id="add-tag">
      <h5 slot="header">
        <strong>Unesite novi tag</strong>
      </h5>
      <div slot="body">
        <div class="row">
          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Tag
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Tag"
                v-model="tagName"
              />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.stop.prevent="saveTag()"
            >
              {{ translations.save }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.cancel }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal id="add-brand">
      <h5 slot="header">
        <strong>Unesite novi brend</strong>
      </h5>
      <div slot="body">
        <div class="row">
          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Naziv
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Brend"
                v-model="brand.title"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
              >Opis</label
            >
            <div class="col-lg-7 col-xl-6">
              <textarea
                type="text"
                class="form-control form-control-modern"
                placeholder="Opis"
                v-model="brand.description"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
              >Slika</label
            >
            <div class="col-lg-7 col-xl-6">
              <input
                type="file"
                class="form-control form-control-modern"
                ref="brandImage"
                accept="image/*"
              />

              <span class="form-text">
                Učitajte sliku rezolucije 200px x 60px
              </span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.stop.prevent="saveBrand()"
            >
              {{ translations.save }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.cancel }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- start: page -->
    <form
      @submit.prevent="submitForm"
      class="ecommerce-form action-buttons-fixed"
      novalidate
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.articleDetails }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.articleDetailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <!-- <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.article.companyId.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.company }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div :class="{ has__error: $v.article.companyId.$anyError }">
                        <treeselect
                          v-model="article.companyId"
                          :multiple="false"
                          :options="companies"
                          :show-count="true"
                          placeholder="Izaberite kompaniju"
                        />
                      </div>
                      <form-error
                        :model="$v.article.companyId"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.company"
                      />
                    </div>
                  </div> -->

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.article.code.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >{{ translations.forms.labels.code }}</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.code"
                        v-model="article.code"
                        @blur="checkIfArticleCodeExists"
                      />

                      <form-error
                        :model="$v.article.code"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.code"
                      />
                      <label
                        v-if="articleCodeExists"
                        class="article-code-error"
                        >{{
                          translations.forms.labels.articleCodeExists
                        }}</label
                      >
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.article.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.title }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="article.title"
                      />

                      <form-error
                        :model="$v.article.title"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.title"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Status artikla
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="article.articleState"
                        :options="articleStates"
                        placeholder="Izaberite status artikla"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.isVisibleOnWeb }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.isVisibleOnWeb"
                          id="visible-on-web"
                        />
                        <label for="visible-on-web"></label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.article.categoryIds.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.category }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div
                        :class="{
                          has__error: $v.article.categoryIds.$anyError,
                        }"
                      >
                        <treeselect
                          v-model="article.categoryIds"
                          :multiple="true"
                          :options="categoriesTreeView"
                          :show-count="true"
                          placeholder="Izaberite kategoriju"
                          v-if="categoriesTreeView"
                        />
                      </div>

                      <form-error
                        :model="$v.article.categoryIds"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.category"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.brand }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="article.brandId"
                      >
                        <option :value="null">Izaberite brend</option>
                        <option
                          :value="brand.id"
                          :key="brand.id"
                          v-for="brand in brands"
                        >
                          {{ brand.title }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-1 col-xl-1">
                      <button
                        class="btn btn-primary btn-md font-weight-semibold py-2 px-4"
                        type="button"
                        @click="addBrand()"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.interestsArea }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="article.interestsAreasIds"
                        :multiple="true"
                        :options="areas"
                        placeholder="Izaberite djelatnost"
                        no-options-text="Nema unesenih djelatnosti."
                        @select="handleChangeAreas"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.catalogNumber }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.catalogNumber"
                        v-model="article.catalogNumber"
                      />

                      <!-- <form-error :model="$v.article.catalogNumber" :dirty="$v.$dirty" label="Kataloški broj" /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end pt-2 mt-1 mb-0"
                    >
                      {{ translations.forms.labels.shortDescription }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <editor
                        name="html-editor"
                        :init="{
                          ...appSettings.tinyMceConfig,
                        }"
                        v-model="article.shortDescription"
                        id="short-description"
                      ></editor>

                      <!-- <form-error :model="$v.article.shortDescription" :dirty="$v.$dirty" label="Kratak opis" /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end pt-2 mt-1 mb-0"
                    >
                      {{ translations.forms.labels.description }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <editor
                        name="html-editor"
                        :init="{
                          ...appSettings.tinyMceConfig,
                        }"
                        v-model="article.description"
                        id="description"
                      ></editor>

                      <div class="form-text">
                        Molimo koristite slike ne veće rezolucije od 600px x
                        600px
                      </div>

                      <!-- <form-error :model="$v.article.description" :dirty="$v.$dirty" label="Opis" /> -->
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3 d-none"
                    :class="{ 'has-danger': $v.article.nc.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.nc }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.nc"
                        v-model.number="article.nc"
                      />

                      <form-error
                        :model="$v.article.nc"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.nc"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Stanje skladišta
                    </label>
                    <div v-if="(article.warehouseTowns || []).length > 0
                      && (article.articleStockAmounts || []).length > 0" class="col-lg-7 col-xl-6">
                      <div v-for="(town, index) in article.warehouseTowns" :key="index">
                          {{ town }}: {{ article.articleStockAmounts[index] && article.articleStockAmounts[index].stockAmount.toFixed(2).replace('.', ',') }}
                      </div>
                    </div>
                    <div v-else class="col-lg-7 col-xl-6">
                      Nema na stanju
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.article.mpc.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.mpc }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.mpc"
                        v-model.number="article.mpc"
                        @input="handleMpcChange"
                      />

                      <form-error
                        :model="$v.article.mpc"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.mpc"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.taxGroup }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="article.taxId"
                      >
                        <option :value="null">Izaberite poreznu grupu</option>
                        <option
                          :value="tax.id"
                          :key="tax.id"
                          v-for="tax in taxes"
                        >
                          {{ tax.description }}
                        </option>
                      </select>

                      <!-- <form-error :model="$v.article.taxId" :dirty="$v.$dirty" label="Porezna grupa" /> -->
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.article.vpc.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.vpc }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.vpc"
                        v-model.number="article.vpc"
                        @input="handleVpcChange"
                      />

                      <form-error
                        :model="$v.article.vpc"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.vpc"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.unitOfMeasure }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="article.unitOfMeasureId"
                      >
                        <option :value="null">Izaberi jedinicu mjere</option>
                        <option
                          :value="unit.id"
                          :key="unit.id"
                          v-for="unit in measurementUnits"
                        >
                          {{ unit.description }}
                        </option>
                      </select>

                      <!-- <form-error :model="$v.article.unitOfMeasureId" :dirty="$v.$dirty" label="Jedinica mjere" /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.nettoWeight }} (kg)
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.nettoWeight"
                        v-model="article.nettoWeight"
                      />

                      <!-- <form-error :model="$v.article.nettoWeight" :dirty="$v.$dirty" label="Netto težina" /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.bruttoWeight }} (kg)
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.bruttoWeight"
                        v-model="article.bruttoWeight"
                      />

                      <!-- <form-error :model="$v.article.bruttoWeight" :dirty="$v.$dirty" label="Netto težina" /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Omjer narudžbe
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        @change="handleOrderQuantityRatio"
                        placeholder="Omjer narudžbe"
                        v-model.number="article.orderQuantityRatio"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.article.minOrderQuantity.$anyError,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Minimalna količina za narudžbu
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        @change="handleMinOrderQuantity"
                        placeholder="Minimalna količina za narudžbu"
                        v-model.number="article.minOrderQuantity"
                      />

                      <form-error
                        :model="$v.article.minOrderQuantity"
                        :dirty="$v.$dirty"
                        label="Minimalna količina za narudžbu"
                      />
                      <!-- <div class="form-text">
                        Ukoliko mijenjate polje "Omjer narudžbe" potrebno je
                        promjeniti i ovo polje na istu vrijednost
                      </div> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Maksimalna količina za narudžbu
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Maksimalna količina za narudžbu"
                        v-model.number="article.maxOrderQuantity"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Dužina
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Dužina"
                        v-model.number="article.length"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Širina
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Širina"
                        v-model.number="article.width"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Visina
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Visina"
                        v-model.number="article.height"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.article.videoUrl.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.videoUrl }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.videoUrl"
                        v-model="article.videoUrl"
                      />

                      <form-error
                        :model="$v.article.videoUrl"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.videoUrl"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.articleType }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="article.attributeArticleType"
                        :options="attributeArticleTypes"
                        :clearable="false"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.tag }}
                    </label>
                    <div class="col-lg-6 col-xl-6">
                      <treeselect
                        v-model="article.tagsIds"
                        :multiple="true"
                        :options="tags"
                        placeholder="Tagovi"
                      />
                    </div>
                    <div class="col-lg-1 col-xl-1">
                      <button
                        class="btn btn-primary btn-md font-weight-semibold py-2 px-4"
                        type="button"
                        @click="addTag()"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Broj dana nakon kojih je artikal dostupan
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Broj dana nakon kojih je artikal dostupan"
                        v-model="article.articleAvailableInDays"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.markArticleAsNew }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.isNewArticle"
                          id="mark-as-new"
                          @change="handeIsNewArticleChange(article)"
                        />
                        <label for="mark-as-new"></label>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="article.isNewArticle"
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Početak</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <datepicker
                        placeholder="Početak"
                        v-model="article.isNewArticleFromDate"
                        input-class="form-control form-control-modern bg-body"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                    </div>
                  </div>

                  <div
                    v-if="article.isNewArticle"
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Kraj
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <datepicker
                        placeholder="Kraj"
                        v-model="article.isNewArticleToDate"
                        input-class="form-control form-control-modern bg-body"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Omogući prezentaciju artikla
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.presentationAvailable"
                          id="presentation-available"
                        />
                        <label for="presentation-available"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Onemogući prodaju B2B
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.disableSelling"
                          id="disable-selling"
                        />
                        <label for="disable-selling"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Onemogući prodaju B2C
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.disableSellingB2C"
                          id="disable-selling-b2c"
                        />
                        <label for="disable-selling-b2c"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Dozvoli recenzije
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.reviewAllowed"
                          id="review-allowed"
                        />
                        <label for="review-allowed"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      B2C Proizvod
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.b2CProduct"
                          id="b2c-product"
                        />
                        <label for="b2c-product"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      B2B Proizvod
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="article.b2BProduct"
                          id="b2b-product"
                        />
                        <label for="b2b-product"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-detail"></i>
                  <h2 class="card-big-info-title">Tabovi</h2>
                  <p class="card-big-info-desc">Dodajte zeljene tabove</p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row align-items-center pb-3">
                        <div class="col-4">
                          <select
                            class="form-control form-control-modern"
                            v-model="tabId"
                          >
                            <option :value="null">Izaberite tab</option>
                            <option
                              :value="tab.id"
                              :key="tab.id"
                              v-for="tab in tabs"
                            >
                              {{ tab.title }}
                            </option>
                          </select>
                        </div>
                        <div class="col-1">
                          <button
                            class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                            type="button"
                            @click="addTab()"
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <div
                        class="tabs"
                        v-if="
                          article && article.tabs && article.tabs.length > 0
                        "
                      >
                        <ul class="nav nav-tabs">
                          <li
                            class="nav-item"
                            v-for="(tab, index) in article.tabs"
                            :key="tab.tabId"
                          >
                            <a
                              class="nav-link"
                              :class="{
                                active: article.tabs.length === index + 1,
                              }"
                              :data-bs-target="`#tab${tab.tabId}`"
                              :href="`#tab${tab.tabId}`"
                              data-bs-toggle="tab"
                            >
                              {{ tab.tabTitle }}
                            </a>
                            <span
                              class="remove-tab"
                              @click.prevent.stop="removeTab(index)"
                              ><i class="bx bx-x"></i
                            ></span>
                          </li>
                        </ul>
                        <div class="tab-content">
                          <div
                            :id="`tab${tab.tabId}`"
                            class="tab-pane"
                            :class="{
                              active: article.tabs.length === index + 1,
                            }"
                            v-for="(tab, index) in article.tabs"
                            :key="tab.tabId"
                          >
                            {{ tab.description }}
                            <editor
                              name="html-editor"
                              :init="{
                                ...appSettings.tinyMceConfig,
                              }"
                              v-model="tab.content"
                              :id="`editor-${tab.tabId}`"
                            >
                            </editor>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="tabs-modern row" style="min-height: 490px">
                <div class="col-lg-2-5 col-xl-1-5">
                  <div
                    class="nav flex-column tabs"
                    id="tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <a
                      class="nav-link active"
                      id="attributes-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#attributes"
                      role="tab"
                      aria-controls="attributes"
                      >Atributi</a
                    >
                    <a
                      class="nav-link"
                      id="variation-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#advanced"
                      role="tab"
                      aria-controls="advanced"
                      >Varijacije</a
                    >
                  </div>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="tab-content" id="tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="attributes"
                      role="tabpanel"
                      aria-labelledby="attributes-tab"
                    >
                      <div class="form-group row">
                        <div class="col">
                          <div class="form-group row pb-3">
                            <div class="form-group row align-items-center pb-3">
                              <div class="col-4">
                                <select
                                  class="form-control form-control-modern"
                                  v-model="attributeId"
                                >
                                  <option :value="null">
                                    Izaberite atribut
                                  </option>
                                  <option
                                    :value="item.id"
                                    :key="item.id"
                                    v-for="item in allAttributes"
                                  >
                                    {{ item.title }}
                                  </option>
                                </select>
                              </div>
                              <div class="col-1">
                                <button
                                  class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                                  type="button"
                                  @click="addAttribute()"
                                >
                                  +
                                </button>
                              </div>
                            </div>

                            <div
                              v-if="
                                article &&
                                article.articleAttributes &&
                                article.articleAttributes.length > 0
                              "
                              class="mt-5"
                            >
                              <div
                                class="form-group row pb-3"
                                v-for="item in article.articleAttributes.filter((item) => item.linkWithArticle === true)"
                                :key="item.id"
                              >
                                <div v-for="property in item.attributePropertiesLinkedWithArticle" 
                                :key="property.id">
                                  <div class="col-xl-2">
                                    <label
                                      v-if="
                                        attributesObj &&
                                        attributesObj[item.attributeId]
                                      "
                                    >
                                      {{ attributesObj[item.attributeId].title }}
                                    </label>
                                  </div>
                                  <div class="col-xl-2">
                                    <label class="control-label"
                                      >Vrijednost(i)</label
                                    >
                                      <treeselect
                                        v-model="property.id"
                                        :options="
                                          attributesObj[item.attributeId]
                                            .attributeProperties
                                        "
                                        :disabled="property.id != null"
                                        @select="onAttributePropertySelect"
                                      >
                                        <label
                                          slot="option-label"
                                          slot-scope="{ node, labelClassName }"
                                          :class="labelClassName"
                                        >
                                          <div
                                            v-if="
                                              attributesObj[item.attributeId]
                                                .attributeStyle !== 1
                                            "
                                          >
                                            {{ node.label }}
                                          </div>
                                          <div v-else>
                                            <div
                                              :style="{
                                                height: '20px',
                                                width: '20px',
                                                background: node.label,
                                              }"
                                            ></div>
                                          </div>
                                        </label>
                                        <div
                                          slot="value-label"
                                          slot-scope="{ node }"
                                          :style="{
                                            paddingTop: '10px'
                                          }"
                                        >
                                          <div
                                            v-if="
                                              attributesObj[item.attributeId]
                                                .attributeStyle === 1
                                            "
                                            :style="{
                                              backgroundColor: node.label,
                                              width: '20px',
                                              height: '20px',
                                              overflow: 'hidden',
                                              border: node.label == '#ffffff' ? '1px solid grey' :'none',
                                            }"
                                          ></div>
                                          <div v-else>{{ node.label }}</div>
                                        </div>
                                      </treeselect>
                                  </div>
                                  <div
                                  class="col-xl-8">
                                    <div
                                      data-bs-toggle="modal"
                                      data-bs-target="#delete-attribute-linked-with-article-modal"
                                      @click="selectAttributeLinkedArticle(item.attributeId, property.id)"
                                      class="ecommerce-attribute-remove text-color-danger float-end"
                                    >
                                      Ukloni
                                    </div>
                                    <label class="control-label"
                                      >Povezani artikal</label
                                    >
                                    <div class="form-group d-flex col-12">
                                              <div class="col-4">
                                                <img
                                                  v-if="property.articleImage != null && property.articleImage != ''"
                                                  class="img-thumbnail article-attribute-thumbnail-sm"
                                                  :src="`${baseUrl}${property.articleImage}`"
                                                />
                                                <div
                                                  v-else
                                                  style="background-color: lightgray;"
                                                  class="img-thumbnail article-attribute-thumbnail-sm text-light d-flex align-items-center
                                                  justify-content-center"
                                                >
                                                  <p v-if="property.articleImage == null">Bez slike</p>
                                                  <p v-else class="text-light">Slika</p>
                                                </div>
                                              </div>
                                  
                                              <div class="col-8">
                                                <div>
                                                  <div class=" row align-items-center mb-1">
                                                    <label class="col-2 control-label text-lg-end mb-0">
                                                      Naziv
                                                    </label>
                                                    <div class="col-10">
                                                      <input
                                                        type="text"
                                                        class="form-control form-control-modern"
                                                        readonly
                                                        placeholder="Naziv"
                                                        v-model="property.articleTitle"
                                                      />
                                                    </div>
                                                  </div>
                                  
                                                  <div class=" row align-items-center mb-1">
                                                    <label class="col-2 control-label text-lg-end mb-0">
                                                      Šifra
                                                    </label>
                                                    <div class="col-10">
                                                      <input
                                                        type="text"
                                                        class="form-control form-control-modern"
                                                        readonly
                                                        placeholder="Šifra"
                                                        v-model="property.articleCode"
                                                      />
                                                    </div>
                                                  </div>
                                  
                                                  <div class=" row align-items-center mb-1">
                                                    <label class="col-2 control-label text-lg-end mb-0">
                                                      Cijena
                                                    </label>
                                                    <div class="col-3">
                                                      <input
                                                        readonly
                                                        type="text"
                                                        class="form-control form-control-modern"
                                                        placeholder="Cijena"
                                                        v-model.number="property.articlePrice"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="form-group row pb-3"
                                v-for="(
                                  item, index
                                ) in article.articleAttributes.filter((item) => item.linkWithArticle === false)"
                                :key="item.id"
                              >
                                <div class="col-xl-3">
                                  <label
                                    v-if="
                                      attributesObj &&
                                      attributesObj[item.attributeId]
                                    "
                                  >
                                    {{ attributesObj[item.attributeId].title }}
                                  </label>
                                </div>
                                <div :class="{
                                  'col-xl-2': attributesObj &&
                                  attributesObj[item.attributeId] &&
                                  attributesObj[item.attributeId].linkWithArticle,
                                  'col-xl-6': attributesObj &&
                                  attributesObj[item.attributeId] &&
                                  attributesObj[item.attributeId].linkWithArticle == false,
                                }">
                                  <div
                                  v-if="attributesObj[item.attributeId] &&
                                  attributesObj[item.attributeId].linkWithArticle == false"
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete-attribute-modal"
                                    @click="selectLinkedAttribute(item.attributeId)"
                                    class="ecommerce-attribute-remove text-color-danger float-end"
                                  >
                                    Ukloni
                                  </div>

                                  <label class="control-label"
                                    >Vrijednost(i)</label
                                  >

                                  <treeselect
                                    v-if="
                                      attributesObj &&
                                      attributesObj[item.attributeId] &&
                                      attributesObj[item.attributeId].linkWithArticle
                                    "
                                    :instance-id="item.attributeId"
                                    v-model="attributesObj[item.attributeId].attributeProperties[0]"
                                    :options="
                                      attributesObj[item.attributeId]
                                        .attributeProperties
                                    "
                                    @deselect="onAttributeChange"
                                    @select="onAttributePropertySelect"
                                  >
                                    <label
                                      slot="option-label"
                                      slot-scope="{ node, labelClassName }"
                                      :class="labelClassName"
                                    >
                                      <div
                                        v-if="
                                          attributesObj[item.attributeId]
                                            .attributeStyle !== 1
                                        "
                                      >
                                        {{ node.label }}
                                      </div>
                                      <div v-else>
                                        <div
                                          :style="{
                                            height: '20px',
                                            width: '20px',
                                            background: node.label,
                                          }"
                                        ></div>
                                      </div>
                                    </label>

                                    <div
                                      slot="value-label"
                                      slot-scope="{ node }"
                                      :style="{
                                        paddingTop: '10px'
                                      }"
                                    >
                                      <div
                                        v-if="
                                          attributesObj[item.attributeId]
                                            .attributeStyle === 1
                                        "
                                        :style="{
                                          backgroundColor: node.label,
                                          width: '20px',
                                          height: '20px',
                                          overflow: 'hidden',
                                          border: node.label == '#ffffff' ? '1px solid grey' :'none',
                                        }"
                                      ></div>
                                      <div v-else>{{ node.label }}</div>
                                    </div>
                                  </treeselect>
                                  <treeselect
                                    v-if="
                                      attributesObj &&
                                      attributesObj[item.attributeId] &&
                                      attributesObj[item.attributeId].linkWithArticle == false
                                    "
                                    :instance-id="item.attributeId"
                                    v-model="item.attributeValues"
                                    :multiple="true"
                                    :options="
                                      attributesObj[item.attributeId]
                                        .attributeProperties
                                    "
                                    @deselect="onAttributeChange"
                                  >
                                    <label
                                      slot="option-label"
                                      slot-scope="{ node, labelClassName }"
                                      :class="labelClassName"
                                    >
                                      <div
                                        v-if="
                                          attributesObj[item.attributeId]
                                            .attributeStyle !== 1
                                        "
                                      >
                                        {{ node.label }}
                                      </div>
                                      <div v-else>
                                        <div
                                          :style="{
                                            height: '20px',
                                            width: '20px',
                                            background: node.label,
                                          }"
                                        ></div>
                                      </div>
                                    </label>

                                    <div
                                      :style="{
                                        background: node.label,
                                      }"
                                      slot="value-label"
                                      slot-scope="{ node }"
                                    >
                                      <div
                                        v-if="
                                          attributesObj[item.attributeId]
                                            .attributeStyle === 1
                                        "
                                        :style="{
                                          backgroundColor: node.label,
                                          width: '20px',
                                          height: '20px',
                                          overflow: 'hidden',
                                        }"
                                      ></div>
                                      <div v-else>{{ node.label }}</div>
                                    </div>
                                  </treeselect>
                                </div>
                                <div 
                                v-if="
                                      attributesObj &&
                                      attributesObj[item.attributeId] &&
                                      attributesObj[item.attributeId].linkWithArticle
                                    "
                                class="col-xl-6">
                                  <div
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete-attribute-modal"
                                    @click="selectLinkedAttribute(index)"
                                    class="ecommerce-attribute-remove text-color-danger float-end"
                                  >
                                    Ukloni
                                  </div>

                                  <label class="control-label"
                                    >Povezani artikal</label
                                  >

                                  <div class="form-group d-flex col-12">
            <div class="col-4">
              <img
                v-if="attributesObj[item.attributeId].attributeProperties[0]?.articleImage"
                class="img-thumbnail article-attribute-thumbnail-sm"
                :src="`${baseUrl}${attributesObj[item.attributeId].attributeProperties[0]?.articleImage}`"
              />
              <div
                v-else
                style="background-color: lightgray;"
                class="img-thumbnail article-attribute-thumbnail-sm text-light d-flex align-items-center
                justify-content-center"
              >
                <p v-if="attributesObj[item.attributeId].attributeProperties[0] == null">Bez slike</p>
                <p v-else class="text-light">Slika</p>
              </div>
            </div>

            <div class="col-8">
              <div>
                <div class=" row align-items-center mb-1">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Naziv
                  </label>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Naziv"
                      v-model="attributesObj[item.attributeId].attributeProperties[0].articleTitle"
                    />
                  </div>
                </div>

                <div class=" row align-items-center mb-1">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Šifra
                  </label>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Šifra"
                      v-model="attributesObj[item.attributeId].attributeProperties[0].articleCode"
                    />
                  </div>
                </div>

                <div class=" row align-items-center mb-1">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Cijena
                  </label>
                  <div class="col-3">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Cijena"
                      v-model.number="attributesObj[item.attributeId].attributeProperties[0].articlePrice"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="tab-pane fade" id="advanced" role="tabpanel">
                      <div class="form-group row pb-3">
                        <div class="row mt-1">
                          <div class="form-group row align-items-center mb-3">
                            <div
                              class="col col-4"
                              v-for="item in variationAttributes"
                              :key="item.id"
                            >
                              <label class="label">{{ item.label }}</label>

                              <treeselect
                                v-model="item.model"
                                :multiple="false"
                                :options="item.values"
                              >
                                <label
                                  slot="option-label"
                                  slot-scope="{ node, labelClassName }"
                                  :class="labelClassName"
                                >
                                  <div
                                    v-if="
                                      variationAttributesObj[item.id]
                                        .attributeStyle !== 1
                                    "
                                  >
                                    {{ node.label }}
                                  </div>
                                  <div v-else>
                                    <div
                                      :style="{
                                        height: '20px',
                                        width: '20px',
                                        background: node.label,
                                      }"
                                    ></div>
                                  </div>
                                </label>

                                <div
                                  slot="value-label"
                                  slot-scope="{ node }"
                                  :style="{
                                    width: '100%',
                                    height: '100%',
                                    padding:
                                      variationAttributesObj[item.id]
                                        .attributeStyle === 1
                                        ? '0.5rem 0'
                                        : 0,
                                  }"
                                >
                                  <div
                                    v-if="
                                      variationAttributesObj[item.id]
                                        .attributeStyle === 1
                                    "
                                    :style="{
                                      backgroundColor: node.label,
                                      width: '100%',
                                      height: '100%',
                                      overflow: 'hidden',
                                      border: '1px solid #ccc',
                                    }"
                                  ></div>
                                  <div v-else>{{ node.label }}</div>
                                </div>
                              </treeselect>
                            </div>
                          </div>
                          <div class="col-md-auto">
                            <button
                              class="btn btn-primary btn-px-3 py-3 font-weight-semibold"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#add-variation-modal"
                              @click="selectVariation()"
                            >
                              Dodaj varijaciju
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        class="table-responsive"
                        v-if="variations.length > 0"
                      >
                        <table
                          class="table table-hover table-bordered table-variations"
                          style="min-width: 550px"
                        >
                          <thead>
                            <tr role="row">
                              <th>SKU</th>
                              <th>Atributi</th>
                              <th>MPC</th>
                              <th>VPC</th>
                              <th>Cijena na popustu</th>
                              <th>Opis</th>
                              <th v-for="(state, index) in warehouseTowns" :key="index">
                                {{ state }}
                              </th>
                              <th>Dimenzije (DxŠxV)</th>
                              <th>Akcije</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in variations"
                              :key="item.id"
                              :class="{
                                odd: index % 2 === 0,
                                even: index % 2 !== 0,
                              }"
                              
                            >
                              <td
                                data-bs-toggle="modal"
                                data-bs-target="#update-variation-modal"
                                @click="selectVariation(item)"
                              >
                                {{ item.code }}
                              </td>

                              <td 
                                data-bs-toggle="modal"
                                data-bs-target="#update-variation-modal"
                                @click="selectVariation(item)"
                              >
                                <div
                                  v-if="Object.keys(attributesObj).length > 0"
                                >
                                  <div
                                    v-for="attribute in item.variationCombinations"
                                    :key="attribute.attributeId"
                                  >
                                    {{
                                      attributesObj[attribute.attributeId]
                                        .title
                                    }}:
                                    {{
                                      attributesObj[
                                        attribute.attributeId
                                      ].attributeProperties.find(
                                        (i) =>
                                          attribute.attributeValueId === i.id
                                      ).label
                                    }}
                                  </div>
                                </div>
                              </td>

                              <td
                                data-bs-toggle="modal"
                                data-bs-target="#update-variation-modal"
                                @click="selectVariation(item)"
                              >
                                {{ item.mpc }}
                              </td>

                              <td
                                data-bs-toggle="modal"
                                data-bs-target="#update-variation-modal"
                                @click="selectVariation(item)"
                              >
                                {{ item.vpc }}
                              </td>

                              <td
                                data-bs-toggle="modal"
                                data-bs-target="#update-variation-modal"
                                @click="selectVariation(item)"
                              >
                                {{ item.salePrice }}
                              </td>

                              <td data-bs-toggle="modal"
                                data-bs-target="#update-variation-modal"
                                @click="selectVariation(item)" class="text-hidden" :title="item.description">
                                {{ item.description || 'N/A' }}
                              </td>

                              <td
                              v-for="(amount, index) in item.articleStockAmounts"
                              :key="index"
                              :class="{ 'stock-amount': item.articleStockAmount === 0,
                              'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                              }"
                              >
                                <strong>{{ amount.articleExists === false ? 'N/A' : amount.stockAmount.toFixed(2).replace('.', ',') }}</strong>
                            </td>

                              <td
                                data-bs-toggle="modal"
                                data-bs-target="#update-variation-modal"
                                @click="selectVariation(item)"
                              >
                                {{ item.length }} x {{ item.width }} x
                                {{ item.height }}
                              </td>

                              <td class="px-4"
                                @click.stop="openDeleteVariationModal(item.id)"
                              >
                                  <i class="bx bx-trash text-4"></i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-detail"></i>
                  <h2 class="card-big-info-title">Povezani artikli</h2>
                  <p class="card-big-info-desc">Dodajte željene artikle</p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row pb-3">
                        <label
                          class="
                            col-lg-5 col-xl-3
                            control-label
                            text-lg-end
                            mb-0
                            mt-2
                          "
                          >Pretraga artikala</label
                        >
                        <div class="col-lg-7 col-xl-6 position-relative">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Pretraga"
                            v-model="searchField"
                            @input="onSearchHandle"
                            @blur="onBlurHandle"
                            @focus="onFocusHandle"
                          />

                          <ul
                            class="article-list bg-body"
                            v-if="showSearchResults"
                          >
                            <li
                              v-for="article in articles"
                              :key="article.id"
                              @click="addLinkedArticle(article)"
                            >
                              <div class="article-wrapper">
                                <img
                                  v-if="article.highlightedImageUrl"
                                  :src="`${baseUrl}${article.highlightedImageUrl}`"
                                  class="article-image"
                                />

                                <img
                                  v-else
                                  class="article-image"
                                  :src="'img/products/product-8.jpg'"
                                />
                                <div class="article-description">
                                  <div class="article-title">
                                    {{ article.title }}
                                  </div>
                                  <div class="article-code">
                                    {{ article.code }}
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div
                          v-if="
                            article.linkedArticles &&
                            article.linkedArticles.length > 0
                          "
                        >
                          <div class="form-group row align-items-center mt-4">
                            <div class="col">
                              <div class="popup-gallery row">
                                <div
                                  v-for="(
                                    item, index
                                  ) in article.linkedArticles"
                                  :key="item.id"
                                  class="
                                    img-fluid
                                    col-xs-4 col-auto
                                    mb-4
                                    me-1
                                    img-wrapper
                                  "
                                >
                                  <div
                                    class="delete-image"
                                    @click="removeLinkedArticle(index)"
                                  >
                                    <i class="bx bx-x"></i>
                                  </div>
                                  <img
                                    v-if="item.highlightedImageUrl"
                                    :src="`${baseUrl}${item.highlightedImageUrl}`"
                                    class="
                                      img-thumbnail img-thumbnail-custom
                                      highlighted
                                    "
                                  />

                                  <img
                                    v-else
                                    class="
                                      img-thumbnail img-thumbnail-custom
                                      highlighted
                                    "
                                    :src="'img/products/product-8.jpg'"
                                  />

                                  <div class="article-title-list">
                                    {{ item.title }}
                                  </div>

                                  <div class="article-code-list">
                                    {{ item.code }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> -->

          <linked-articles v-model="article.linkedArticles" />
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-camera"></i>
                  <h2 class="card-big-info-title">Slike artikla</h2>
                  <p class="card-big-info-desc">
                    Označite sliku kao glavnu ili dodajte nove iz galerije
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center"
                    v-if="
                      article &&
                      article.gallery &&
                      article.gallery.images &&
                      article.gallery.images.length > 0
                    "
                  >
                    <div class="col">
                      <div
                        class="popup-gallery row"
                        v-if="article.gallery && article.gallery.images"
                      >
                        <div
                          class="img-fluid col-xs-4 col-auto mb-4 me-1 img-wrapper"
                          v-for="image in article.gallery.images"
                          @click.stop="highlightImage(image.id)"
                          :key="image.id"
                        >
                          <div
                            class="delete-image"
                            @click.prevent.stop="deleteImage(image.id)"
                          >
                            <i class="bx bx-x"></i>
                          </div>
                          <img
                            class="img-thumbnail img-thumbnail-custom"
                            :src="`${baseUrl}${image.url}`"
                            :class="{ highlighted: image.isHighlighted }"
                          />
                          <input
                            class="form-control form-control-modern img-order"
                            type="text"
                            v-model.number="image.ordinalNumber"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center">
                    <button
                      data-bs-toggle="modal"
                      type="button"
                      data-bs-target="#media-library"
                      class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                    >
                      <i class="bx bx-upload text-lg-4 py-1" /> Upload
                    </button>
                    <modal id="media-library" css-class="modal-xl">
                      <h5 slot="header">
                        <strong>Biblioteka</strong>
                      </h5>
                      <div slot="body">
                        <media-library
                          v-if="article.gallery && article.gallery.images"
                          v-model="article.gallery.images"
                        />
                      </div>
                      <div slot="footer">
                        <div class="row">
                          <div class="col-md-12 text-end">
                            <button
                              type="button"
                              class="btn btn-primary px-4 mx-2"
                              @click.prevent="closeMediaLibraryModal"
                            >
                              Zatvori
                            </button>
                          </div>
                        </div>
                      </div>
                    </modal>
                    <modal id="upload-modal" css-class="modal-xl">
                      <h5 slot="header">
                        <strong> Upload image </strong>
                      </h5>
                      <div slot="body">
                        <MediaLibraryModalBody modal-id="upload-modal" />
                      </div>
                      <div slot="footer">
                        <div class="row">
                          <div class="col-md-12 text-end">
                            <button
                              type="button"
                              class="btn btn-primary px-4 mx-2"
                              @click.prevent="closeUploadModal('upload-modal')"
                            >
                              Zatvori
                            </button>
                          </div>
                        </div>
                      </div>
                    </modal>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>

        <div class="d-flex gap-3">
          <button
            type="button"
            @click="$router.go(-1)"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </button>
          <div class="col-12 col-md-auto px-md-1">
            <a
              :href="`${frontBaseUrl}article/${article.id}/${slugify(
                article.title
              )}`"
              target="_blank"
              class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
            >
              <i class="bx bx-exit text-4 me-2"></i> Pregled artikla
            </a>
          </div>
          <button
            type="button"
            @click="copyArticle()"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-copy text-4 me-2"></i>
            {{ translations.copyArticle }}
          </button>

          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteArticle }}</strong>
        </h5>
        <div slot="body">
          <span v-html="articleModalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteArticle"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="delete-variation-image-modal" z-index="10000">
        <h5 slot="header">
          <strong>{{ translations.deleteVariationImage }}</strong>
        </h5>
        <div slot="body"></div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteVariationImage"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="delete-variation-modal" z-index="10000">
        <h5 slot="header">
          <strong>{{ translations.deleteVariation }}</strong>
        </h5>
        <div slot="body"></div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteVariation"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="delete-attribute-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteAttribute }}</strong>
        </h5>
        <div slot="body">
          <span v-html="removeAttributeModalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="removeLinkedAttribute"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="delete-attribute-linked-with-article-modal">
        <h5 slot="header">
          <strong>Izbriši vrijednost atributa</strong>
        </h5>
        <div slot="body">
          <span v-html="removeAttributeModalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="removeAttributeLinkedWithArticle"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="attribute-article-link-modal"
      cssStyle="width: 1000px"
      >
        <h5 slot="header">
          <h4>Atribut: {{ selectedAttribute?.title }}</h4>
        </h5>
        <div slot="body">
          <div
            class="row align-items-center pb-3"
          >
              <div class="col-lg-12">
                <treeselect
                  v-model="articleId"
                  loadingText="Učitavanje..."
                  :noResultsText="articleNoResultsText"
                  searchPromptText="Unesite najmanje 3 karaktera"
                  :load-options="loadArticles"
                  :cache-options="false"
                  :async="true"
                  :options="articles"
                  :default-options="articles"
                  placeholder="Izaberite artikal"
                />
              </div>
          </div>

          <div class="form-group d-flex col-12">
            <div class="col-4">
              <img
                v-if="selectedAttributeArticle?.image"
                class="img-thumbnail article-attribute-thumbnail"
                :src="`${baseUrl}${selectedAttributeArticle?.image}`"
              />
              <div
                v-else
                style="background-color: lightgray;"
                class="img-thumbnail article-attribute-thumbnail text-light d-flex align-items-center
                justify-content-center"
              >
                <p v-if="selectedAttributeArticle == null">Bez slike</p>
                <p v-else class="text-light">Slika</p>
              </div>
            </div>

            <div class="col-8">
              <div>
                <div class=" row align-items-center mb-3">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Naziv
                  </label>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Naziv"
                      v-model="selectedAttributeArticle.title"
                    />
                  </div>
                </div>

                <div class=" row align-items-center mb-3">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Šifra
                  </label>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Šifra"
                      v-model="selectedAttributeArticle.code"
                    />
                  </div>
                </div>

                <div class=" row align-items-center mb-3">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Cijena
                  </label>
                  <div class="col-3">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Cijena"
                      v-model.number="selectedAttributeArticle.price"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-default px-4 mx-2"
                data-bs-dismiss="modal"
                @click.prevent.stop="closeArticleAttributeModal()"
              >
                Odustani
              </button>
              <button
                type="button"
                class="btn btn-primary px-4"
                @click.prevent.stop="saveAttributeWithArticle()"
              >
                Dodaj
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="add-variation-modal" css-class="modal-2xl">
        <h5 slot="header">
          <strong>{{ translations.addVariation }}</strong>
        </h5>
        <div slot="body">
          <div class="form-group row align-items-center mb-3">
            <div
              class="col col-4"
              :class="{
                'col-4': variationAttributes.length % 3 === 0,
                'col-6': variationAttributes.length % 2 === 0,
              }"
              v-for="item in variationAttributes"
              :key="item.id"
            >
              <label class="label">{{ item.label }}</label>

              <treeselect
                v-model="item.model"
                :multiple="false"
                :options="item.values"
              >
                <label
                  slot="option-label"
                  slot-scope="{ node, labelClassName }"
                  :class="labelClassName"
                >
                  <div
                    v-if="variationAttributesObj[item.id].attributeStyle !== 1"
                  >
                    {{ node.label }}
                  </div>
                  <div v-else>
                    <div
                      :style="{
                        height: '20px',
                        width: '20px',
                        background: node.label,
                      }"
                    ></div>
                  </div>
                </label>

                <div
                  slot="value-label"
                  slot-scope="{ node }"
                  :style="{
                    width: '100%',
                    height: '100%',
                    padding:
                      variationAttributesObj[item.id].attributeStyle === 1
                        ? '0.5rem 0'
                        : 0,
                  }"
                >
                  <div
                    v-if="variationAttributesObj[item.id].attributeStyle === 1"
                    :style="{
                      backgroundColor: node.label,
                      width: '100%',
                      height: '100%',
                      overflow: 'hidden',
                      border: '1px solid #ccc',
                    }"
                  ></div>
                  <div v-else>{{ node.label }}</div>
                </div>
              </treeselect>
            </div>
          </div>

          <div class="form-group row align-items-center">
            <div class="col">
              <button
                data-bs-toggle="modal"
                type="button"
                data-bs-target="#media-library-variation"
                class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 mb-2"
              >
                <i class="bx bx-upload text-lg-4 py-1" /> Upload
              </button>

              <div
                class="form-group row align-items-center"
                v-if="selectedVariation && selectedVariation.gallery"
              >
                <div class="col">
                  <div class="popup-gallery row">
                    <div
                      class="img-fluid col-xs-4 col-auto mb-4 me-1 img-wrapper"
                      v-for="image in selectedVariation.gallery.images"
                      :key="image.id"
                    >
                      <div
                        class="delete-image"
                        @click.prevent.stop="openDeleteVariationImageModal(image.id)"
                      >
                        <i class="bx bx-x"></i>
                      </div>
                      <img
                        class="img-thumbnail img-thumbnail-custom"
                        :src="`${baseUrl}${image.url}`"
                        :class="{ highlighted: image.isHighlighted }"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3"
            :class="{ 'has-danger': $v.selectedVariation.code.$anyError }"
          >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              SKU
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="SKU"
                v-model="selectedVariation.code"
              />

              <form-error
                :model="$v.selectedVariation.code"
                :dirty="$v.$dirty"
                label="SKU"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3"
            :class="{ 'has-danger': $v.selectedVariation.mpc.$anyError }"
          >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              MPC
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="MPC"
                v-model.number="selectedVariation.mpc"
                @input="calculateVariationVpc(selectedVariation)"
              />

              <form-error
                :model="$v.selectedVariation.mpc"
                :dirty="$v.$dirty"
                label="MPC"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3"
            :class="{ 'has-danger': $v.selectedVariation.vpc.$anyError }"
          >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              VPC
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="VPC"
                v-model.number="selectedVariation.vpc"
                @input="calculateVariationMpc(selectedVariation)"
              />

              <form-error
                :model="$v.selectedVariation.vpc"
                :dirty="$v.$dirty"
                label="VPC"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Neto težina (kg)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Neto težina (kg)"
                v-model="selectedVariation.nettoWeight"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3" >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Bruto težina (kg)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Bruto težina (kg)"
                v-model="selectedVariation.bruttoWeight"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Dimenzije (DxŠxV) (cm)
            </label>

            <div class="col-lg-7 col-xl-6">
              <div class="row">
                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    placeholder="Duzina"
                    v-model="selectedVariation.length"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Sirina"
                    v-model="selectedVariation.width"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Visina"
                    v-model="selectedVariation.height"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Količina na zalihi
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Kolicina na zalihi"
                v-model="selectedVariation.stockAmount"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3"
          >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Akcijska cijena
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Akcijska cijena"
                v-model="selectedVariation.salePrice"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Opis
            </label>
            <div class="col-lg-7 col-xl-6">
              <textarea
                type="text"
                class="form-control form-control-modern"
                placeholder="Opis"
                v-model="selectedVariation.description"
              />
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 d-flex gap-2 justify-content-end text-end">
              <button
                class="btn btn-primary px-4"
                type="button"
                @click.prevent.stop="saveVariation(selectedVariation)"
              >
                {{ translations.save }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.cancel }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="media-library-variation" css-class="modal-xl">
        <h5 slot="header">
          <strong>Biblioteka</strong>
        </h5>
        <div slot="body">
          <media-library
            v-if="selectedVariation.gallery"
            v-model="selectedVariation.gallery.images"
            modal-id="upload-modal-variation"
          />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent="closeMediaLibraryModal"
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="upload-modal-variation" css-class="modal-xl">
        <h5 slot="header">
          <strong> Upload image </strong>
        </h5>
        <div slot="body">
          <MediaLibraryModalBody modal-id="upload-modal-variation" />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent="closeUploadModal('upload-modal-variation')"
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="update-variation-modal" css-class="modal-2xl">
        <h5 slot="header">
          <strong>{{ translations.updateVariation }}</strong>
        </h5>
        <div slot="body">
          <div class="form-group row align-items-center mb-3">
            <div
              class="col col-4"
              :class="{
                'col-4':
                  (selectedVariation.variationCombinations || []).length % 3 === 0,
                'col-6':
                  (selectedVariation.variationCombinations || []).length % 2 === 0,
              }"
              v-for="item in selectedVariation.variationCombinations || []"
              :key="item.id"
            >
              <label class="label">{{
                variationAttributesObj[item.attributeId] && variationAttributesObj[item.attributeId].label
              }}</label>
              <select
                class="form-control"
                :key="item.id"
                v-model="item.attributeValueId"
              >
                <option :value="null">Bilo koja vrijednost</option>
                <option
                  :value="v.id"
                  v-for="v in (variationAttributesObj[item.attributeId] && variationAttributesObj[item.attributeId].values) || []"
                  :key="v.id"
                >
                  {{ v.label }}
                </option>
              </select>
            </div>
          </div>

          <div>
            <button
              data-bs-toggle="modal"
              type="button"
              data-bs-target="#media-library-variation-update"
              class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 mb-2"
            >
              <i class="bx bx-upload text-lg-4 py-1" /> Upload
            </button>
          </div>

          <div
            class="form-group row align-items-center"
            v-if="selectedVariation && selectedVariation.gallery"
          >
            <div class="col">
              <div class="popup-gallery row">
                <div
                  class="img-fluid col-xs-4 col-auto mb-4 me-1 img-wrapper"
                  v-for="image in selectedVariation.gallery.images"
                  :key="image.id"
                >
                  <div
                    class="delete-image"
                    @click.prevent.stop="openDeleteVariationImageModal(image.id)"
                  >
                    <i class="bx bx-x"></i>
                  </div>
                  <img
                    class="img-thumbnail img-thumbnail-custom"
                    :src="`${baseUrl}${image.url}`"
                    :class="{ highlighted: image.isHighlighted }"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3"
            :class="{ 'has-danger': $v.selectedVariation.code.$anyError }"
          >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              SKU
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="SKU"
                v-model="selectedVariation.code"
              />

              <form-error
                :model="$v.selectedVariation.code"
                :dirty="$v.$dirty"
                label="Akcijska cijena"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3"
            :class="{ 'has-danger': $v.selectedVariation.mpc.$anyError }"
          >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              MPC
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="MPC"
                v-model="selectedVariation.mpc"
                @input="calculateVariationVpc(selectedVariation)"
              />

              <form-error
                :model="$v.selectedVariation.mpc"
                :dirty="$v.$dirty"
                label="MPC"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3"
            :class="{ 'has-danger': $v.selectedVariation.vpc.$anyError }"
          >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              VPC
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="VPC"
                v-model="selectedVariation.vpc"
                @input="calculateVariationMpc(selectedVariation)"
              />

              <form-error
                :model="$v.selectedVariation.vpc"
                :dirty="$v.$dirty"
                label="VPC"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Neto težina (kg)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Neto težina (kg)"
                v-model="selectedVariation.nettoWeight"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Bruto težina (kg)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Bruto težina (kg)"
                v-model="selectedVariation.bruttoWeight"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Dimenzije (DxŠxV) (cm)
            </label>

            <div class="col-lg-7 col-xl-6">
              <div class="row">
                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    placeholder="Duzina"
                    v-model="selectedVariation.length"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Sirina"
                    v-model="selectedVariation.width"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Visina"
                    v-model="selectedVariation.height"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Količina na zalihi
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Količina na zalihi"
                v-model="selectedVariation.stockAmount"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3"
          >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Akcijska cijena
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Akcijska cijena"
                v-model="selectedVariation.salePrice"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Opis
            </label>
            <div class="col-lg-7 col-xl-6">
              <textarea
                type="text"
                class="form-control form-control-modern"
                placeholder="Opis"
                v-model="selectedVariation.description"
              />
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                class="btn btn-primary px-4 mx-2"
                type="button"
                @click.prevent.stop="saveVariation(selectedVariation)"
              >
                {{ translations.save }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.cancel }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="media-library-variation-update" css-class="modal-xl">
        <h5 slot="header">
          <strong>Biblioteka</strong>
        </h5>
        <div slot="body">
          <media-library
            v-if="selectedVariation.gallery"
            v-model="selectedVariation.gallery.images"
            modal-id="upload-modal-variation-update"
          />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent="closeMediaLibraryModal"
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="upload-modal-variation-update" css-class="modal-xl">
        <h5 slot="header">
          <strong> Upload image </strong>
        </h5>
        <div slot="body">
          <MediaLibraryModalBody modal-id="upload-modal-variation-update" />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent="closeUploadModal('upload-modal-variation-update')"
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
// import 'bootstrap/js/src/collapse';
import Datepicker from 'vuejs-datepicker';
import { format } from 'date-fns';
import Vue from 'vue';
import editor from '@tinymce/tinymce-vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import slugify from '@/filters/slugify';
import { debounce } from 'lodash';
// import VSwatches from 'vue-swatches';
// Import the styles too, typically in App.vue or main.js
// import 'vue-swatches/dist/vue-swatches.css';

import api from '@/services/api';
import helpers from '@/services/helpers';
import { translations, pager } from '@/mixins';
import validations from './validation-schema/add';
import variationsValidations from './validation-schema/addVariation';
import config from '@/config';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';
import LinkedArticles from './LinkedArticles.vue';
import MediaLibrary from './MediaLibrary.vue';
import MediaLibraryModalBody from '@/components/shared/MediaLibraryModal.vue';
import { EventBus } from '@/main';

import bs from 'vuejs-datepicker/dist/locale/translations/bs';

export default {
  name: 'EditArticle',
  mixins: [translations, pager],
  components: {
    // VSwatches,
    Datepicker,
    editor,
    FormError,
    Treeselect,
    Modal,
    LinkedArticles,
    MediaLibrary,
    MediaLibraryModalBody,
  },
  validations: {
    article: validations,
    selectedVariation: variationsValidations,
  },
  data() {
    return {
      articleCodeExists: false,
      selectedImages: [],
      brand: {
        title: '',
        description: '',
      },
      tagName: '',
      baseUrl: config.baseUrl,
      showSearchResults: false,
      tabId: null,
      dropzone: '',
      dropzoneVariations: '',
      dropzoneCreateVariations: '',
      deleteImagesIds: [],
      highlightedImageId: null,
      selectedDeleteAttribute: null,
      selectedDeleteAttributeLinkedWithArticle: null,
      selectedDeleteArticlePropertyId: null,
      selectedAttribute: null,
      selectedAttributeProperty: null,
      articleId: null,
      attributeArticleType: 1,
      highlightImageUrl: '',
      attributeArticleTypes: [
        {
          id: 1,
          label: 'Jednostavni',
        },
        {
          id: 2,
          label: 'Varijabilni',
        },
      ],
      attributeId: null,
      selectedVariation: {
        gallery: {
          images: [],
        },
      },
      deleteVariationImageId: null,
      deleteVariationId: null,
      gallery: [],
      articleSearchQuery: '',
      pendingArticleCallbacks: [],
    };
  },
  computed: {
    articleNoResultsText() {
      return this.articleSearchQuery.length < 3
        ? 'Unesite najmanje 3 karaktera'
        : 'Nema rezultata';
    },
    appSettings() {
      return config.appSettings;
    },
    frontBaseUrl() {
      return config.frontBaseUrl;
    },
    bs() {
      return bs;
    },
    articleStates() {
      return helpers.articleStates;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return {
        to: date,
      };
    },
    articleModalText() {
      return this.translations.areYouSureArticle.replace(
        '{article}',
        `<strong>${this.article.title}</strong>`
      );
    },
    removeAttributeModalText() {
      return this.translations.areYouSureAttributeArticle;
    },
    article() {
      const article = this.$store.getters.getArticle;

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.gallery = article?.gallery?.images?.map((item) => ({
        ...item,
      }));

      return article;
    },
    articles() {
      return this.$store.getters.getArticles.filter((item) => item.id != this.article.id).map((item) => {
        return {
          id: item.id,
          label: item.title,
          code: item.code,
          image: item.highlightedImageUrl,
          price: item.mpc,
          title: item.title
        };
      });
    },
    selectedAttributeArticle() {
      return this.articles.find((item) => item.id == this.articleId) ?? {
        title: '',
        code: '',
        price: ''
      };
    },
    categories() {
      return this.$store.getters.getSimplifiedCategories;
    },
    brands() {
      return this.$store.getters.getBrands;
    },
    taxes() {
      return this.$store.getters.getTaxes;
    },
    measurementUnits() {
      return this.$store.getters.getMeasurementUnits;
    },
    tabs() {
      return this.$store.getters.getTabs;
    },
    categoriesTreeView() {
      return this.$store.getters.getCategoriesTree;
    },
    areas() {
      const areas = this.$store.getters.getInterestsAreas;

      if (!areas.length) {
        return [];
      }

      const selectAll = {
        id: 0,
        label: 'Oznaci sve',
      };

      return [
        selectAll,
        ...areas.map((item) => {
          return {
            label: item.title,
            id: item.id,
          };
        }),
      ];
    },
    attributesObj() {
      return this.$store.getters.getAttributesAsObj;
    },
    allAttributes() {
      return this.$store.getters.getAttributes;
    },
    // Mapped selected attributes used on add variation modal
    variationAttributes() {
      return this.article?.articleAttributes?.filter((item) => !item.linkWithArticle).map((item) => {
        const attribute = this.attributesObj[item.attributeId];

        const values = item.attributeValues.map((a) => {
          const obj = attribute?.attributeProperties?.find((i) => i.id === a);
          return {
            ...a,
            id: a,
            label: obj?.label,
          };
        });

        return {
          ...item,
          id: item.attributeId,
          label: attribute?.title,
          values,
          model: null,
        };
      }) || [];
    },
    variations() {
      return this.$store.getters.getArticleVariations;
    },
    warehouseTowns() {
      return this.$store.getters.getVariationsWarehouseTowns;
    },
    variationAttributesObj() {
      const obj = {};
      this.variationAttributes.forEach((item) => {
        obj[item.id] = item;
      });
      return obj;
    },
    companies() {
      const companies = this.$store.getters.getCompanies.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
      return companies;
    },
    tags() {
      return this.$store.getters.getTags;
    },
  },
  methods: {
    slugify,
    closeMediaLibraryModal() {
      $('#media-library').modal('hide');
      $('#media-library-variation').modal('hide');
      $('#media-library-variation-update').modal('hide');
    },
    closeUploadModal(modalId) {
      $(`#${modalId}`).modal('hide');
      EventBus.$emit(`clear-upload-modal-data:${modalId}`);
    },
    customFormatter(date) {
      return format(date, 'dd.MM.yyyy.');
    },
    handeIsNewArticleChange({ isNewArticle }) {
      if (isNewArticle) {
        const currentDate = new Date();
        (this.article.isNewArticleFromDate =
          this.article.isNewArticleFromDate || new Date()),
          (this.article.isNewArticleToDate =
            this.article.isNewArticleToDate ||
            new Date().setDate(currentDate.getDate() + 7));
      }
    },
    addTab() {
      if (!this.tabId) return;

      const exist = this.article.tabs.find((tab) => tab.tabId === this.tabId);

      // There is already tab with that id in the list
      if (exist) return;

      const selectedTab = this.tabs.find((tab) => tab.id === this.tabId);
      selectedTab.tabId = selectedTab.id;
      selectedTab.tabTitle = selectedTab.title;
      selectedTab.content = '';
      this.article.tabs.push(selectedTab);
    },
    checkIfArticleCodeExists() {
      if (!this.article.code || !this.article.code.trim()) {
        this.articleCodeExists = false;
        return;
      }

      api
        .checkIfArticleCodeExists(this.article.id, this.article.code)
        .then(() => {
          // this.$toast.info(response?.data?.info);
          this.articleCodeExists = false;
        })
        .catch(() => {
          this.articleCodeExists = true;
        });
    },
    submitForm() {
      this.$v.article.$touch();
      this.articleCodeExists = false;

      if (this.$v.article.$invalid) {
        this.$toast.error(this.translations.forms.notValid);
        this.$nextTick(() => {
          let elem = document.querySelector('.has-danger');
          elem.scrollIntoView(true);
        });
        return;
      }

      const { article } = this;

      if (article.isNewArticle) {
        article.isNewArticleFromDate = new Date(article.isNewArticleFromDate);
        article.isNewArticleToDate = new Date(article.isNewArticleToDate);
      } else {
        delete article.isNewArticleFromDate;
        delete article.isNewArticleToDate;
      }

      const mediaLibraryArticleImages = this.gallery.map((i, index) => ({
        ...i,
        ordinalNumber: i.ordinalNumber || index + 1,
        isHighlighted: i.isHighlighted || false,
      }));

      const isHighlighted = mediaLibraryArticleImages.some(
        (item) => item.isHighlighted
      );

      if (!isHighlighted && mediaLibraryArticleImages.length) {
        mediaLibraryArticleImages[0].isHighlighted = true;
      }

      article.mediaLibraryArticleImages = mediaLibraryArticleImages;

      if (!article.maxOrderQuantity) {
        article.maxOrderQuantity = null;
      }

      // delete article.gallery;

      const requests = [api.updateArticle(article)];

      if (this.deleteImagesIds.length > 0) {
        requests.push(api.deleteArticleImages(this.deleteImagesIds));
      }

      if (this.article.linkedArticles.length >= 0) {
        const linkedArticlesIds = this.article.linkedArticles.map(
          (item) => item.id
        );
        requests.push(
          api.updateLinkedArticles({ articleId: article.id, linkedArticlesIds })
        );
      }

      if (this.article.articleAttributes.length > 0) {
        const payload = [];

        this.article.articleAttributes.forEach((item) => {
          if (item.attributePropertiesLinkedWithArticle && !item.attributePropertiesLinkedWithArticle.find((attr) => attr.id == null))
            payload.push({
              articleId: this.article.id,
              attributeId: item.attributeId,
              attributeValues: item.linkWithArticle ? 
              item.attributePropertiesLinkedWithArticle.map((prop) => ({
                attributeValueId: prop.id,
                linkedArticleId: prop.articleId,
              })) : item.attributeValues.map((value) => ({
                attributeValueId: value,
                linkedArticleId: null
              })),
            });
        });

        this.article.articleAttributes.forEach((item) => {
          if (!item.attributePropertiesLinkedWithArticle )
            payload.push({
              articleId: this.article.id,
              attributeId: item.attributeId,
              attributeValues: item.attributeValues.map((value) => ({
                attributeValueId: value,
                linkedArticleId: null
              })),
            });
        });

        requests.push(api.updateArticleAttributes(payload));
      }

      Promise.all(requests)
        .then((response) => {
          this.$toast.info(response[0].data.info);
          this.$router.back(); // Go back to articles
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    handleMinOrderQuantity() {
      this.article.orderQuantityRatio = this.article.minOrderQuantity;
    },
    handleOrderQuantityRatio() {
      this.article.minOrderQuantity = this.article.orderQuantityRatio;
    },
    copyArticle() {
      this.$v.article.$touch();

      this.$store.dispatch('makeCopyOfArticle', this.article);
      this.$router.push({ name: 'CopyArticle' });
      return;
    },
    saveAttributeWithArticle() {
      if (!this.articleId) {
        this.$toast.error('Odabir artikla je obavezan');
        return;
      }

      const attribute = this.article.articleAttributes.find((item) => item.attributeId == this.attributeId)
      const selectedProperty = attribute.attributePropertiesLinkedWithArticle.find((item) => item.id === this.selectedAttributeProperty);

      if (!selectedProperty) {
        attribute.attributePropertiesLinkedWithArticle.push({
          id: this.selectedAttributeProperty,
          articleId: this.articleId,
          articleTitle: this.selectedAttributeArticle.title,
          articleCode: this.selectedAttributeArticle.code,
          articlePrice: this.selectedAttributeArticle.price,
          articleImage: this.selectedAttributeArticle.image,      
        })
      } else {
          selectedProperty.id = this.selectedAttributeProperty;
          selectedProperty.articleId = this.articleId;
          selectedProperty.articleTitle = this.selectedAttributeArticle.title;
          selectedProperty.articleCode = this.selectedAttributeArticle.code;
          selectedProperty.articlePrice = this.selectedAttributeArticle.price;
          selectedProperty.articleImage = this.selectedAttributeArticle.image;
          attribute.attributePropertiesLinkedWithArticle = [...attribute.attributePropertiesLinkedWithArticle.filter((item) => item.articleId != null)];
        }
      
      this.selectedAttribute = null;
      this.selectedAttributeProperty = null;
      this.attributeId = null;
      this.articleId = null;

      $('#attribute-article-link-modal').modal('hide');
    },
    closeArticleAttributeModal() { 
      this.selectedAttributeArticle = null;
      this.articleId = null;      

      $('#attribute-article-link-modal').modal('hide');
    },
    loadArticles({ callback, searchQuery }) {
      this.articleSearchQuery = (searchQuery || '').trim();

      if (this.articleSearchQuery.length < 3) {
        callback(null, []);
        return;
      }

      this.pendingArticleCallbacks.push(callback);
      this.searchArticles();
    },
    searchArticles: debounce(function() {
      const callbacks = this.pendingArticleCallbacks;
      this.pendingArticleCallbacks = [];

      this.articleId = null;

      this.$store.dispatch('getArticles', {
        sortBy: 'title',
        isSortAscending: false,
        page: 1,
        retrieveAll: true,
        quickSearch: this.articleSearchQuery,
        brandIds: [],
        categoryIds: [],
        attributeValuesIds: [],
        tagIds: [],
      }).then(() => {
          callbacks.forEach((cb) => cb(null, this.articles));
        })
        .catch((err) => {
          callbacks.forEach((cb) => cb(err));
        });
    }, 500),
    highlightImage(id) {
      const images = this.gallery;
      this.gallery = images.map((image) => {
        image.isHighlighted = false;
        return image;
      });

      const index = images.findIndex((image) => image.id === id);

      this.gallery[index].isHighlighted = true;
      this.highlightedImageId = id;
    },
    deleteImage(id) {
      const images = this.article.gallery.images;
      this.article.gallery.images = images.filter((image) => image.id !== id);
      this.deleteImagesIds.push(id);

      if (id === this.highlightedImageId) {
        this.highlightedImageId = null;
      }
    },
    deleteArticle() {
      api
        .deleteArticles([this.article.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Articles' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: 'Articles' });
        });
    },
    removeTab(index) {
      this.article.tabs.splice(index, 1);
    },
    addAttribute() {
      if (!this.attributeId) {
        this.$toast.error('Izaberite atribut');
        return;
      }

      const attribute = this.attributesObj[this.attributeId];

      if (!attribute) return;

      this.$nextTick(() => {
        const attributeProperties = attribute.attributeProperties.map((item) => item);

        if (attribute.linkWithArticle) {
          let attributePropertiesLinkedWithArticle = attribute.attributePropertiesLinkedWithArticle ?? [];

          attributePropertiesLinkedWithArticle.push({
            id: this.selectedAttributeProperty,
            articleId: this.articleId,
            articleTitle: '',
            articleCode: '',
            articlePrice: '',
            articleImage: '',
          });

          attributePropertiesLinkedWithArticle = attributePropertiesLinkedWithArticle.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.id === item.id && t.articleId === item.articleId)
          );

          this.$set(attribute, 'attributePropertiesLinkedWithArticle', attributePropertiesLinkedWithArticle);
        }

        this.$set(attribute, 'attributeProperties', attributeProperties);
        this.$set(attribute, 'attributeValues', []);
        this.$set(attribute, 'attributeId', attribute.id);
        this.$set(attribute, 'model', []);

        let articleAttributes = this.article.articleAttributes;

        if (articleAttributes.length === 0 && attribute.linkWithArticle == false) {
          articleAttributes.push(attribute);
        } else {
          const item = articleAttributes.find((i) => i.attributeId === attribute.id);
        
          if (!item || item.id != this.selectedAttributeProperty) {
            articleAttributes.push(attribute);
          } else if (item && item.linkWithArticle) {
            item.attributePropertiesLinkedWithArticle.push({
              id: this.selectedAttributeProperty,
              articleId: this.articleId,
              articleTitle: '',
              articleCode: '',
              articlePrice: '',
              articleImage: '',
            });

            item.attributePropertiesLinkedWithArticle = item.attributePropertiesLinkedWithArticle.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.id === item.id && t.articleId === item.articleId)
            );
          } else if (item && !item.linkWithArticle) {
            this.$toast.error('Atribut je već dodan');
          }
        }

        articleAttributes = articleAttributes.filter(
          (item, index, self) => index === self.findIndex((t) => t.attributeId === item.attributeId)
        );

        this.selectedAttribute = attribute;
        this.selectedAttributeProperty = null;

        this.$set(this.article, 'articleAttributes', articleAttributes);
      });
    },
    removeAttributeLinkedWithArticle() {
      const attribute = this.article.articleAttributes.find((item) => item.attributeId == this.selectedDeleteAttributeLinkedWithArticle);

      attribute.attributePropertiesLinkedWithArticle = attribute.attributePropertiesLinkedWithArticle
      .filter((item) => item.id != this.selectedDeleteArticlePropertyId)

      if (attribute.attributePropertiesLinkedWithArticle.length == 0) {
        this.article.articleAttributes = this.article.articleAttributes.filter((item) => item.attributeId != attribute.attributeId)
      }

      if (this.attributeId) {
        this.attributeId = null;
      }

      if (this.selectedDeleteArticlePropertyId) {
        api.deleteArticleAttributeValueId({
          articleId: this.article.id,
          attributeId: attribute.attributeId,
          attributeValueId: this.selectedDeleteArticlePropertyId
        })
        .then(() => {
          this.$toast.info('Atribut uspješno uklonjen');
        })
        .catch(() => {
          this.$toast.error('Dogodila se greška')
        })
      }
    },
    removeLinkedAttribute() {
      const attribute =
        this.article.articleAttributes.find(
          (item) => item.attributeId == this.selectedDeleteAttribute
        );

      api
        .deleteArticleAttribute({
          articleId: this.article.id,
          attributeId: attribute.attributeId,
        })
        .then(() => {
          this.$toast.info('Atribut uspješno uklonjen.');
          this.article.articleAttributes = this.article.articleAttributes.filter(
            (item) => item.attributeId != attribute.attributeId
          );
        })
        .catch(() => {
          this.$toast.error('Dogodila se greška!');
        });
    },
    selectLinkedAttribute(attributeId) {
      this.selectedDeleteAttribute = attributeId;
    },
    selectAttributeLinkedArticle(attributeId, propertyId) {
      this.selectedDeleteAttributeLinkedWithArticle = attributeId;
      this.selectedDeleteArticlePropertyId = propertyId;
    },
    onAttributeChange(node, instanceId) {
      api
        .deleteArticleAttributeValueId({
          articleId: this.article.id,
          attributeId: instanceId,
          attributeValueId: node.id,
        })
        .then(() => {
          this.$toast.info('Vrijednost atributa uspješno uklonjena');
          this.$forceUpdate();
        });
    },
    onAttributePropertySelect(node) {
      this.selectedAttributeProperty = node.id;

      const attribute = this.article.articleAttributes.find((item) => item.attributeId == this.attributeId)

      if (attribute) {
        if (attribute.attributePropertiesLinkedWithArticle.find((item) => item.id == node.id)) {
          this.$toast.error('Vrijednost atributa je već dodana');
          return;
        }

        $('#attribute-article-link-modal').modal('show');
      }
    },
    calculateVariationMpc(variation) {
      const currentArticleTax = this.taxes.find((item) => item.id == this.article.taxId);      
      
      variation.mpc = parseFloat(variation.vpc * (1 + currentArticleTax.value / 100), 10);
    },
    calculateVariationVpc(variation) {
      const currentArticleTax = this.taxes.find((item) => item.id == this.article.taxId);      

      variation.vpc = parseFloat(variation.mpc / (1 + currentArticleTax.value / 100), 10);
    },
    selectVariation(variation) {
      // Add variation
      if (!variation) {
        this.selectedVariation = {
          title: '',
          code: '',
          enabled: false,
          mpc: this.article.mpc,
          vpc: this.article.vpc,
          salePrice: null,
          stockAmount: 0,
          nettoWeight: this.article.nettoWeight,
          bruttoWeight: this.article.bruttoWeight,
          width: 0,
          height: 0,
          length: 0,
          description: '',
          gallery: {
            images: [],
          },
        };
      } else {
        // Update variation
        this.selectedVariation = variation;
      }
    },
    saveVariation(variation) {
      this.$v.selectedVariation.$touch();

      if (this.$v.selectedVariation.$invalid) {
        this.$toast.error(this.translations.forms.notValid);
        this.$nextTick(() => {
          let elem = document.querySelector('.has-danger');
          elem.scrollIntoView(true);
        });
        return;
      }

      const requestData = {
        articleId: this.article.id,
        title: variation.title || 'test',
        description: variation.description,
        code: variation.code,
        nettoWeight: parseFloat(variation.nettoWeight, 10),
        bruttoWeight: parseFloat(variation.bruttoWeight, 10),
        height: parseFloat(variation.height, 10),
        length: parseFloat(variation.length, 10),
        width: parseFloat(variation.width, 10),
        mpc: parseFloat(variation.mpc, 10),
        vpc: parseFloat(variation.vpc, 10),
        salePrice: parseFloat(variation.salePrice, 10),
        stockAmount: parseInt(variation.stockAmount, 10),
        mediaLibraryArticleImages: [],
        variationCombinations: [],
      };

      // Create variation
      if (!variation.id) {
        this.variationAttributes.forEach((item) => {
          requestData.variationCombinations.push({
            attributeId: item.id,
            attributeValueId: item.model,
          });
        });

        const isValid = requestData.variationCombinations.every(item => item.attributeValueId);
        if (!isValid) {
          this.$toast.error('Molimo odaberite sve dostupne atribute prilikom kreiranja varijacije!');
          return;
        }

        requestData.mediaLibraryArticleImages =
          this.selectedVariation.gallery.images.map((item, index) => ({
            ...item,
            mediaLibraryFileId: item.mediaLibraryFileId || item.id,
            isHighlighted: index == 0
          }));
      }

      // Update variation
      if (variation.id) {
        requestData.id = variation.id;

        requestData.mediaLibraryArticleImages =
          this.selectedVariation.gallery.images.map((item, index) => ({
            ...item,
            mediaLibraryFileId: item.mediaLibraryFileId || item.id,
            isHighlighted: index == 0
          }));

        variation.variationCombinations.forEach((item) => {
          requestData.variationCombinations.push({
            attributeId: item.attributeId,
            attributeValueId: item.attributeValueId,
          });
        });

        const isValid = requestData.variationCombinations.every(item => item.attributeValueId);
        if (!isValid) {
          this.$toast.error('Molimo odaberite sve dostupne atribute prilikom kreiranja varijacije!');
          return;
        }

        api.updateVariation(requestData).then(() => {
          this.$store.dispatch('getArticleVariations', this.$route.params.id);
          $('#update-variation-modal').modal('hide');
        });
        return;
      }

      api.createVariation(requestData).then(() => {
        this.$store.dispatch('getArticleVariations', this.$route.params.id);
        $('#add-variation-modal').modal('hide');
      });

      this.$v.variation.$reset();

      this.selectedVariation = {
          title: '',
          code: '',
          enabled: false,
          mpc: this.article.mpc,
          vpc: this.article.vpc,
          salePrice: null,
          stockAmount: 0,
          nettoWeight: this.article.nettoWeight,
          bruttoWeight: this.article.bruttoWeight,
          width: 0,
          height: 0,
          length: 0,
          description: '',
          gallery: {
            images: [],
          },
        };
    },
    openDeleteVariationImageModal(imageId) {
      this.deleteVariationImageId = imageId;
      $('#delete-variation-image-modal').modal('show');
    },
    openDeleteVariationModal(variationId) {
      this.deleteVariationId = variationId;
      $('#delete-variation-modal').modal('show');
    },
    deleteVariationImage() {
      api
        .deleteVariationImage({
          imageId: this.deleteVariationImageId,
          variationId: this.selectedVariation.id,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getArticleVariations', this.$route.params.id);
          this.selectedVariation.gallery.images = this.selectedVariation.gallery.images.filter(
            (item) => item.id !== this.deleteVariationImageId
          );
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
          this.$store.dispatch('getArticleVariations', this.$route.params.id);
        })
        .finally(() => {
          this.deleteVariationId = null;
        });
    },
    deleteVariation() {
      api
        .deleteVariation(this.deleteVariationId)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getArticleVariations', this.$route.params.id);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
          this.$store.dispatch('getArticleVariations', this.$route.params.id);
        });
    },
    handleChangeAreas(node) {
      if (node.id === 0) {
        // All selected
        if (this.article.interestsAreasIds.length === this.areas.length - 1) {
          Vue.nextTick(() => {
            this.article.interestsAreasIds = [];
          });
        } else {
          Vue.nextTick(() => {
            this.article.interestsAreasIds = this.areas
              .filter((i) => i.id !== 0)
              .map((i) => i.id);
          });
        }
      }
    },
    addTag() {
      $('#add-tag').modal('show');
    },
    saveTag() {
      api
        .createTag({ title: this.tagName })
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        })
        .finally(() => {
          $('#add-tag').modal('hide');
          this.tagName = '';
        });
    },
    addBrand() {
      $('#add-brand').modal('show');
    },
    saveBrand() {
      const { title, description } = this.brand;

      const formData = new FormData();

      formData.append('title', title);
      formData.append('description', description);

      if (this.$refs.brandImage.files[0]) {
        formData.append('Image', this.$refs.brandImage.files[0]);
      }
      api
        .createBrand(formData)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err);
        })
        .finally(() => {
          $('#add-brand').modal('hide');
          this.brand.title = '';
          this.brand.description = '';
          this.$store.dispatch('getBrands', {
            sortBy: 'title',
            isSortAscending: true,
            retrieveAll: true,
          });
        });
    },
    handleMpcChange() {
      this.article.vpc = parseFloat((this.article.mpc / 1.17).toFixed(2), 10);
    },
    handleVpcChange() {
      this.article.mpc = parseFloat((this.article.vpc * 1.17).toFixed(2), 10);
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getArticleById', this.$route.params.id);
    this.$store.dispatch('getSimplifiedCategories', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getMeasurementUnits', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getTaxes', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getBrands', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getTabs', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getInterestsAreas', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getAttributes', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getVariationsWarehouseTowns', this.$route.params.id);
    this.$store.dispatch('getArticleVariations', this.$route.params.id);
    this.$store.dispatch('getCompanies', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getTags', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
  },
  watch: {
    'article.gallery.images'() {
      this.gallery = this.article?.gallery?.images?.map((item) => {
        item.mediaLibraryFileId = item.mediaLibraryFileId || item.id;
        return item;
      });
    },
  },
};
</script>

<style lang="scss">
@import './assets/scss/article.scss';
</style>
